const initState = {
  missingEntries: [],
  weeklyReport: [],
  productivityReport: [],
  accomplishmentReport: [],
  projectCumulative: null,
};

const reportsReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_MISSING_ENTRIES":
      return {
        ...state,
        missingEntries: action.missingEntries,
      };
    case "GET_MISSING_ENTRIES_BY_USER":
      return {
        ...state,
        missingEntriesByUser: action.missingEntriesByUser,
      };
    case "GET_MISSING_ENTRIES_BY_EMPLOYEE":
      return {
        ...state,
        missingEntriesByEmployee: action.missingEntriesByEmployee,
      };
    case "GET_WEEKLY_REPORTS":
      return {
        ...state,
        weeklyReport: action.weeklyReport,
      };
    case "GET_PRODUCTIVITY_REPORTS":
      return {
        ...state,
        productivityReport: action.productivityReport,
      };
    case "GET_ACCOMPLISHMENT_REPORTS":
      return {
        ...state,
        accomplishmentReport: action.accomplishmentReport,
      };
    case "GET_TIMESHEET_CUMULATIVE_REPORT":
      return {
        ...state,
        projectCumulative: action.projectCumulative,
      };
    case "RESET_TIMESHEET_CUMULATIVE_REPORT":
      return {
        ...state,
        projectCumulative: null,
      };
    case "REFRESH_REPORTS":
      return {
        ...state,
        missingEntries: state.missingEntries,
        weeklyReport: state.weeklyReport,
        projectCumulative: state.projectCumulative,
      };
    default:
      return state;
  }
};

export default reportsReducer;
